import request from "@/utils/request";


export function requestAmrieh() {

    return request({
        url: "vazifeh/send",
        method: "post",

    });
}
